export type SlugSeparator = "-" | "_";

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export function generateSlug(input: string, separator: SlugSeparator = "-") {
  const edgeSeparator = new RegExp(`^${escapeRegExp(separator)}+|${escapeRegExp(separator)}+$`, "g");

  return input
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s_-]/g, "")
    .trim()
    .replace(/[\s_-]+/g, separator)
    .replace(edgeSeparator, "");
}
